import { PartConfiguratorFormApi } from "src/api/generated/erp/configurator/api/partConfiguratorFormApi.ts";
import i18n from "i18next";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { LabelValueView } from "src/components/common/misc/LabelValueView.tsx";
import { concatWithPipe } from "src/utils/strings.tsx";
import { formatIsoString } from "src/utils/dayjsUtils.ts";

export interface PartConfiguratorVersionInfoViewProps {
	configuratorType: PartConfiguratorType;
}

export const PartConfiguratorVersionInfoView = ({ configuratorType }: PartConfiguratorVersionInfoViewProps) => {
	return (
		<AsyncFetchRender
			fetch={() => PartConfiguratorFormApi.getConfiguratorVersionInfo({ configuratorType })}
			content={(versionInfo) => (
				<LabelValueView
					sx={{ margin: 1 }}
					items={[
						{
							label: i18n.t("part"),
							value: concatWithPipe(versionInfo.partNo, versionInfo.partDescription1),
						},
						{
							label: i18n.t("part_revision"),
							value: versionInfo.partRevisionNumber,
						},
						{
							label: i18n.t("active_from"),
							value: formatIsoString(versionInfo.partRevisionValidFrom, "L"),
						},
						{
							label: i18n.t("revision_note"),
							value: versionInfo.partRevisionNote,
							multiline: true,
						},
					]}
				/>
			)}
		/>
	);
};
